export const theme = {
  colors: {
    white: '#ffffff',
    black: '#070724',
    darkGray: '#38384F',
    lightGray: '#838391',
    yellow: '#EDA249',
    orange: '#CD5120',
    red: '#D83A34',
    darkOrange: '#D14C32',
    teal: '#1ec2a4',
    lightBlue: '#419EBB',
    darkBlue: '#2d68f0',
    purple: '#6f2ed6',

    Mercury: '#DEF4FC',
    Venus: '#F7CC7F',
    Earth: '#545BFE',
    Mars: '#FF6A45',
    Jupiter: '#ECAD7A',
    Saturn: '#FCCB6B',
    Uranus: '#65F0D5',
    Neptune: '#497EFA',
  },
};
